import React from 'react'
import { Card, Input, Space, Button, Select, Row, Col, Statistic } from 'antd'
import { SearchOutlined, GiftOutlined } from '@ant-design/icons'
import { useTrials } from '../hooks/useTrials'
import { useTrialActions } from '../hooks/useTrialActions'
import { TrialsTable } from '../components/TrialsTable'
import { TrialAssignmentModal } from '../components/TrialAssignmentModal'
import { TrialExtensionModal } from '../components/TrialExtensionModal'

export const TrialsScreen: React.FC = () => {
    const {
        trials,
        searchText, setSearchText,
        statusFilter, setStatusFilter,
        totalTrials,
        activeTrials
    } = useTrials()

    const {
        isAssignmentModalOpen,
        handleAssignTrial,
        handleExtendTrial,
        handleRevokeTrial,
        handleAssignmentSubmit,
        closeAssignmentModal,
        isExtensionModalOpen,
        extensionTrial,
        handleExtensionSubmit,
        closeExtensionModal
    } = useTrialActions()

    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Row gutter={16}>
                <Col span={12}>
                    <Card>
                        <Statistic
                            title="Active Trials"
                            value={activeTrials}
                            prefix={<GiftOutlined style={{ color: '#52c41a' }} />}
                        />
                    </Card>
                </Col>
                <Col span={12}>
                    <Card>
                        <Statistic
                            title="Total Trials History"
                            value={totalTrials}
                        />
                    </Card>
                </Col>
            </Row>

            <Card>
                <Space style={{ marginBottom: 16 }}>
                    <Input
                        placeholder="Search trials..."
                        prefix={<SearchOutlined />}
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        style={{ width: 300 }}
                    />
                    <Select
                        placeholder="Filter by status"
                        style={{ width: 150 }}
                        value={statusFilter}
                        onChange={setStatusFilter}
                    >
                        <Select.Option value="all">All Status</Select.Option>
                        <Select.Option value="active">Active</Select.Option>
                        <Select.Option value="expired">Expired</Select.Option>
                        <Select.Option value="revoked">Revoked</Select.Option>
                    </Select>
                    <Button type="primary" icon={<GiftOutlined />} onClick={handleAssignTrial}>
                        Assign New Trial
                    </Button>
                </Space>

                <TrialsTable
                    trials={trials}
                    onExtend={handleExtendTrial}
                    onRevoke={handleRevokeTrial}
                />
            </Card>

            <TrialAssignmentModal
                open={isAssignmentModalOpen}
                onCancel={closeAssignmentModal}
                onSubmit={handleAssignmentSubmit}
            />

            <TrialExtensionModal
                open={isExtensionModalOpen}
                merchantName={extensionTrial?.merchantName}
                onCancel={closeExtensionModal}
                onSubmit={handleExtensionSubmit}
            />
        </Space>
    )
}
